document.addEventListener('DOMContentLoaded', comparisonInit);

function comparisonInit() {
  const comparisons = document.querySelectorAll('.comparison');
  for (const comparison of comparisons) {
    const wrapper = comparison.querySelector('.row');
    if (!wrapper) continue;

    const scroller = wrapper.querySelector('.overflow-scroll');
    if (!scroller) continue;

    // event listeners (correct)
    scroller.addEventListener('scroll', () => updateShadow(scroller, wrapper));
    window.addEventListener('resize', () => updateShadow(scroller, wrapper));

    // initial state
    updateShadow(scroller, wrapper);
  }
}

function updateShadow(scroller, wrapper) {
  const { scrollLeft, clientWidth, scrollWidth } = scroller;

  const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

  wrapper.classList.toggle('shadow-right', !atEnd);
}
